<style>

.edit{
  position: fixed;
  right: 20px;
  bottom: 80px;
  z-index: 100;
}
.bg{
  background-color: #ccc;
  color: black;
  border-radius: 10px;
  box-shadow: 0 0 10px #333;
}
.pad{
  padding: 0 10px;
  font-size: 31px;
}

</style>

<div class="edit">
  <div class="bg">
    <div class="pad" on:click="{ () => dispatch('click') }">
      +
    </div>
  </div>
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

</script>